/**
 * Single source of truth for legal document versions.
 * When bumping a version, update here AND in:
 *  - src/pages/Terms.tsx or Privacy.tsx (visible content)
 *  - supabase/functions/_shared/legalContent.ts (PDF mirror)
 */
export const TERMS_VERSION = "2.2";
export const PRIVACY_VERSION = "2.0";

/**
 * Versioned acknowledgment of the ANAF / SPV disclaimer (Terms §9.1).
 * Required once before the first e-Factura submission. Bump when the
 * disclaimer text changes materially.
 */
export const ANAF_DISCLAIMER_VERSION = "1.0";
